const getHighlightedToNodeBranchIndex = ({
  edges,
  highlightedNodeIds,
  getIsBranchEdgeHighlighted
}) => {
  let highlightedToNodeBranchIndex = -1;
  highlightedToNodeBranchIndex = edges.findIndex(edge => {
    const toNode = edge.getToNode();
    const currentEdgeId = edge.getId();
    let isHighlighted = false;
    if (toNode && highlightedNodeIds) {
      isHighlighted = highlightedNodeIds.has(toNode);
    }
    // Intentionally overriding this with getIsBranchEdgeHighlighted evaluation
    if (currentEdgeId !== null && getIsBranchEdgeHighlighted) {
      isHighlighted = getIsBranchEdgeHighlighted(currentEdgeId);
    }
    return isHighlighted;
  });
  return highlightedToNodeBranchIndex;
};
const getIsCurrentBranchInHighlightedPath = (meetingPointSurroundingBranches, currentBranchIndex, highlightedToNodeBranchIndex) => {
  if (highlightedToNodeBranchIndex === -1) {
    return false;
  }
  const meetingPointPrevBranchIndex = meetingPointSurroundingBranches.previousBranchIndex;
  const meetingPointNextBranchIndex = meetingPointSurroundingBranches.nextBranchIndex;
  return (
    // if the meeting point is not yet found, that means we are still to the left of the meeting point
    meetingPointNextBranchIndex === -1 && meetingPointPrevBranchIndex === -1 && highlightedToNodeBranchIndex < currentBranchIndex || currentBranchIndex >= meetingPointPrevBranchIndex && currentBranchIndex <= highlightedToNodeBranchIndex || currentBranchIndex <= meetingPointNextBranchIndex && currentBranchIndex >= highlightedToNodeBranchIndex || currentBranchIndex === meetingPointNextBranchIndex && currentBranchIndex === meetingPointPrevBranchIndex
  );
};

/*
  Note(sumkumar): We are splitting the top connector edge for each branch into three segments:
    1. *****  Main segment - The segment from the node's center towards the parent node's center
    2. =====  Other segment - The segment extending past the parent node's center
    3. -----  Connecting segment - The segment connecting to the next branch

  Few rules for a branch which has a segment that meets the parent node's edge,
    - connecting segment length = half of the node wrapper width of the branch
    - main segment length = difference between the node's center and the parent node's center or half of the node wrapper width of the branch(which directly doesn't meet the parents node), whichever is smaller
    - other segment length = half of the node wrapper width - Main segment length


                             ................................
                             :                              :
                             :        Branch Action         :
                             :                              :
                             :..............................:
                                              |
                                              |
             .--------------------.===========.********.------------------.-- ... next segments
             |                       other       main  |   connecting
             |                                         |
 ............|............                   ..........|.............
 :       Branch 1        :                   :       Branch 2       :         ...  next branches
 :.......................:                   :......................:


  This enables us to highlight each segment separately and it takes expanding branches across multiple levels into account, because the nodeWrapperWidth controls width of these segments.
  The highlighted node ids are used to determine which segment should be highlighted.
*/

export const getBranchTopSegmentsInfo = ({
  currentBranchIndex,
  distanceFromMeetingPoint,
  nodeWrapperWidth,
  edges,
  meetingPointSurroundingBranches,
  highlightedNodeIds,
  getIsBranchEdgeHighlighted
}) => {
  let mainSegmentLeft;
  let otherSegmentLeft;
  let connectingSegmentLeft;
  let isMainSegmentHighlighted = false;
  let isOtherSegmentHighlighted = false;
  let isConnectingSegmentHighlighted = false;
  const halfWrapperWidth = nodeWrapperWidth / 2;
  const mainSegmentWidth = Math.min(Math.abs(distanceFromMeetingPoint), halfWrapperWidth);
  const otherSegmentWidth = halfWrapperWidth - mainSegmentWidth;
  const connectingSegmentWidth = halfWrapperWidth;
  const highlightedToNodeBranchIndex = getHighlightedToNodeBranchIndex({
    highlightedNodeIds,
    edges,
    getIsBranchEdgeHighlighted
  });

  // This is necessary to determine the position of the segments
  const isCenterTowardsLeft = distanceFromMeetingPoint > 0;
  const isCurrentBranchInHighlightedPath = getIsCurrentBranchInHighlightedPath(meetingPointSurroundingBranches, currentBranchIndex, highlightedToNodeBranchIndex);
  if (isCenterTowardsLeft) {
    otherSegmentLeft = 0;
    mainSegmentLeft = otherSegmentWidth;
    connectingSegmentLeft = halfWrapperWidth;
    if (isCurrentBranchInHighlightedPath) {
      isOtherSegmentHighlighted = highlightedToNodeBranchIndex < currentBranchIndex;
      isMainSegmentHighlighted = highlightedToNodeBranchIndex >= currentBranchIndex;
      isConnectingSegmentHighlighted = highlightedToNodeBranchIndex > currentBranchIndex;
    }
  } else {
    connectingSegmentLeft = 0;
    mainSegmentLeft = halfWrapperWidth;
    otherSegmentLeft = mainSegmentLeft + mainSegmentWidth;
    if (isCurrentBranchInHighlightedPath) {
      isMainSegmentHighlighted = highlightedToNodeBranchIndex <= currentBranchIndex;
      isOtherSegmentHighlighted = highlightedToNodeBranchIndex > currentBranchIndex;
      isConnectingSegmentHighlighted = highlightedToNodeBranchIndex < currentBranchIndex;
    }
  }
  return {
    mainSegmentWidth,
    mainSegmentLeft,
    isMainSegmentHighlighted,
    otherSegmentWidth,
    otherSegmentLeft,
    isOtherSegmentHighlighted,
    connectingSegmentWidth,
    connectingSegmentLeft,
    isConnectingSegmentHighlighted
  };
};